<template>
  <b-card class="rounded-xl border-none" no-body>
 

    <div v-if="!isShowCreate">
     
     <div class="flex justify-end">
      <base-button outline type="success" class="flex" @click="isShowCreate =true">
        <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Create New SMS Template
      </base-button>
     </div>
    <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer  mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="CategoryData"
    >
      <el-table-column label="SID" prop="sid" min-width="80px" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.sid }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Name" min-width="150px" prop="title" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.title }}</span>
        </template>
      </el-table-column>

      <el-table-column label="SMS Content" min-width="230px" prop="content" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.content }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Unicode / Flash"
        min-width="140px"
        prop="uniCode"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.uniCode }}</span>
        </template>
      </el-table-column>


           <el-table-column
        label="Sender ID"
        min-width="120px"
        prop="senderKey"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.senderKey }}</span>
        </template>
      </el-table-column>

           <el-table-column
        label="Created Date	"
        min-width="140px"
        prop="date"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.date }}</span>
        </template>
      </el-table-column>

    <el-table-column
        label="Action"
        min-width="140px"
        prop="action"
        sortable
      >
        <template v-slot="{ row }">
      
          <base-button size="sm" type="primary">{{ row.action }}</base-button>
        </template>
      </el-table-column>
    </el-table>
     <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="10"
        :total="50"
      ></base-pagination>
    </b-card-footer>
 </div>

<div v-show="isShowCreate">
<CreateNewSmsTemplate />
</div>
   

  </b-card>
</template>
<script>

import CreateNewSmsTemplate from "./CreateNewSmsTemplate"
import CategoryData from "./CategoryData";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
   
    CreateNewSmsTemplate
  },
  data() {
    return {
      CategoryData,
      currentPage: 1,
      editModal: false,
      isShowCreate:false
    };
  }
};
</script>
